/**
 * List marital status Model
 * @authour Nihala Dilshi
 *
 */

import { BaseAPI } from 'soxo-bootstrap-core';

class ListMaritalstatus extends BaseAPI {
    constructor() {
        super();
    }

    get id() {
        return 'mrts_id';
    }

    get getEndpoint() {
        return 'listmaritalstatus';
    }

    get path() {
        return `listmaritalstatus`;
    }

    get getName() {
        return this.modelName;
    }

    get modelName() {
        return `listmaritalstatus`;
    }

}

export default ListMaritalstatus;
